const jsonRequest = (url, method, body) =>
  fetch(url, {
    method: method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async (response) => {
    const data = await response.json();
    if (!response.ok || data.success === false) {
      const error = new Error(data.error || 'Request failed');
      error.payload = data;
      throw error;
    }
    return data;
  });

export const sendPhoneVerification = (onSuccess, onError) => {
  jsonRequest('/api/v2/phone_verification', 'POST')
    .then(onSuccess)
    .catch((error) => onError(error.message));
};

export const confirmPhoneVerification = (code, onSuccess, onError) => {
  jsonRequest('/api/v2/phone_verification/confirm', 'POST', { code: code })
    .then(onSuccess)
    .catch((error) => onError(error.message));
};

export const getPhoneVerificationDelivery = (onSuccess) => {
  fetch('/api/v2/phone_verification/delivery', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) onSuccess(data);
    })
    .catch(() => {});
};

export const updateVerificationPhone = (phone, onSuccess, onError) => {
  jsonRequest('/api/v2/phone_verification/phone', 'PATCH', { phone: phone })
    .then(onSuccess)
    .catch((error) => onError(error.message));
};
